import style from "modules/PsyProfile/components/Qualifications/style.module.scss"
import { Tabs, BulletList, Collapsible } from "components"
import { Analytics } from "utils/analytics"
import { unique } from "utils/utils"
import { Psychologist } from "utils/interfaces"
import { Text } from "ui-kit/components-branded/Text"
const COLLAPSE_AFTER = 2

interface SkillsProps {
    psy: Psychologist
}

function TabContent({ id, title, items }: { id: string; title: string; items: string[] }) {
    return (
        <Tabs.Tab id={id} title={title} data-testid={`psy-profile-title`}>
            <BulletList items={items} collapseAfter={5} />
        </Tabs.Tab>
    )
}

export function Qualifications({ psy }: SkillsProps) {
    const reportTabSelect = (tabId: string) => {
        Analytics.profile_skills_tab_selected({ tabId })
    }
    const validMethods = psy.methods.filter((method) => !!method.description)

    return (
        <section className={style.container}>
            <h2 className={style.title} data-testid="psy-profile-qualification-title">
                Квалификация
            </h2>
            <Tabs onChangeTab={reportTabSelect}>
                <Tabs.Tab id="education" title="Образование">
                    <BulletList
                        title="Высшее образование и переподготовка"
                        items={unique(psy.higher_education)}
                        collapseAfter={2}
                        className="mb-4"
                    />
                    <BulletList
                        title="Практическое долгосрочное обучение"
                        items={unique(psy.practical_education)}
                        collapseAfter={2}
                    />
                </Tabs.Tab>
                <Tabs.Tab id="methods" title="Особенности работы">
                    <Collapsible
                        collapsible={validMethods.length > COLLAPSE_AFTER}
                        renderList={(collapsed) => {
                            const visibleMethods = collapsed
                                ? validMethods.slice(0, COLLAPSE_AFTER)
                                : validMethods

                            return (
                                <div
                                    className={style.methods}
                                    data-testid="psy-profile-qualification-methods"
                                >
                                    {visibleMethods.map(({ name, description }) => (
                                        <div key={name}>
                                            <Text
                                                className={style.methodsTitle}
                                                isAccent
                                                data-testid="psy-profile-qualification-methods-title"
                                            >
                                                {name}
                                            </Text>
                                            <Text data-testid="psy-profile-qualification-methods-description">
                                                {description}
                                            </Text>
                                        </div>
                                    ))}
                                </div>
                            )
                        }}
                    />
                </Tabs.Tab>

                {psy.features_of_work.length > 0 && (
                    <TabContent
                        id="features"
                        title="Особенности работы"
                        items={unique(psy.features_of_work)}
                    />
                )}

                {psy.expertise.length > 0 && (
                    <TabContent id="expertise" title="Техники" items={unique(psy.expertise)} />
                )}
            </Tabs>
        </section>
    )
}
